/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import FormStandardInput from '../components/common/inputs/FormStandardInput';


export default (inputsData, formikProps, grayBackground = true, alwaysDisabled = false) => {
  const {
    values, handleChange, handleBlur, isSubmitting, errors, touched, setFieldValue, setFieldTouched, setFieldError,
  } = formikProps;
  return inputsData.map(inputData => {
    const { id, disabled } = inputData;
    // Transforming possible undefined value to false
    const touchedValue = !!touched[id];
    return (
      <FormStandardInput
        key={id}
        {...inputData}
        value={values[id]}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled || alwaysDisabled || !!isSubmitting}
        error={touchedValue && !!errors[id]}
        errorMessage={errors[id]}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        setFieldError={setFieldError}
        touched={touchedValue}
        grayBackground={grayBackground}
      />
    );
  });
};
